var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDefectList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36,
    height: 32,
    rx: 9,
    stroke: "#5C5C5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 23.75V19.25H19.75V20.75H25.75V22.25H19.75V23.75H18.25ZM12.25 22.25V20.75H16.75V22.25H12.25ZM15.25 19.25V17.75H12.25V16.25H15.25V14.75H16.75V19.25H15.25ZM18.25 17.75V16.25H25.75V17.75H18.25ZM21.25 14.75V10.25H22.75V11.75H25.75V13.25H22.75V14.75H21.25ZM12.25 13.25V11.75H19.75V13.25H12.25Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDefectList);
export default __webpack_public_path__ + "static/media/select_defect_list.ccfdf2e07403345998a8722b871c41dd.svg";
export { ForwardRef as ReactComponent };